import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FaExclamationTriangle } from "react-icons/fa";

export type CampaignPublishErrorsBannerProps = {
  messages: string[];
};

/**
 * Campaign-level publish error callout (Meta publish pipeline). Matches Figma `title bar`:
 * rose field, 12px Work Sans, warning glyph in 14×24 slot, content vertically centered in the bar.
 */
export function CampaignPublishErrorsBanner({
  messages,
}: CampaignPublishErrorsBannerProps) {
  if (messages.length === 0) return null;

  return (
    <Box
      bg="#f3e8e9"
      borderRadius="md"
      px={3}
      py="6px"
      minH="44px"
      w="full"
      role="alert"
      display="flex"
      alignItems="center"
    >
      <HStack align="center" gap={3} w="full">
        <Box
          w="14px"
          h="24px"
          flexShrink={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icon
            as={FaExclamationTriangle}
            color="#991b1b"
            w="14px"
            h="13px"
            display="block"
            aria-hidden
          />
        </Box>
        <VStack align="stretch" spacing={2} flex={1} minW={0}>
          {messages.map((msg, i) => (
            <Text
              key={i}
              fontFamily="Work Sans"
              fontSize="xs"
              fontWeight="medium"
              color="#991b1b"
              lineHeight="1.3"
              whiteSpace="pre-line"
            >
              {messages.length > 1 ? `${i + 1}. ${msg}` : msg}
            </Text>
          ))}
        </VStack>
      </HStack>
    </Box>
  );
}
